import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { connect } from "react-redux";
import Grid from '@mui/material/Grid';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import LoaderComponent from "../components/LoaderComponent";
import { getUserDetailsLoading, getRoleChangeRequests } from "../selector/selectors";
import { loadRoleChangeRequestList } from "../api/elevationapi";
import SearchBoxComponent from "../components/SearchBoxComponent";
import RolesChangeRequestList from "../components/RolesChangeRequestList";
import { Link } from "react-router-dom";

function ManageRolesElevationRequest({
  isLoading,
  requestList,
  loadingRoleChangeRequests
}) {
   
    const [page, setPage] = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchValue, setSearchValue] = React.useState('');

    useEffect(() => {
        loadingRoleChangeRequests('');
    }, [loadingRoleChangeRequests]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleSearchUser = (event) => {
        setSearchValue(event.target.value);
        loadingRoleChangeRequests(event.target.value);
      };

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        loadingRoleChangeRequests(searchValue,pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        loadingRoleChangeRequests(searchValue,0,event.target.value);
    }

    return (
        <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Tab label="Role Elevation Request" value="1" />
                                <Link className="tabingLinks" to="/web/permission/request-list">Permissions Request</Link>
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'space-between'}}>
                                <SearchBoxComponent
                                handleChangeTextValue = {(e)=>handleSearchUser(e,'')}
                                label='Search Email'
                                />   
                            </Grid>
                            <RolesChangeRequestList requestList={requestList} page={page} rowsPerPage={rowsPerPage} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} />
                        </TabPanel>
                    </Grid>
                </TabContext>
            </Grid>
        </Box>
    );
}

const mapStateToProps = (state) => ({
  isLoading   :  getUserDetailsLoading(state),  
  requestList :  getRoleChangeRequests(state),  
});

const mapDispatchToProps = (dispatch) => ({
    //addNewRole: (data)  => dispatch(addNewRole(data)),
    loadingRoleChangeRequests: (searchValue,page,rowsPerPage) => dispatch(loadRoleChangeRequestList(searchValue,page,rowsPerPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageRolesElevationRequest);

